export const type = {
  changeMode: '[ColorMode] SET_MODE',
};
